"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDriverAbilityToCustomizePlan = exports.getDriverScopeOfCoverage = exports.getDriverPayVetDirectly = exports.getDriverPoliciesOffered = exports.getDriverFinancialStrengthRating = exports.getDriverCanBuyOnline = exports.getDriverNAICComplaints = exports.getDriverEaseOfUse = exports.getDriverDiscounts = exports.getDriverCoverageOptions = exports.getDriverBottomLine = void 0;

var _insurance = require("../selectors/insurance");

var _format = require("../utils/format");

var _drivers = require("../constants/drivers");

/**
 * @module
 *
 * @description Insurance driver configurations
 */

/**
 * Get the bottom line driver
 * @param {object} offer - The marketplace offer.
 * @returns {object} - The insurance driver.
 */
var getDriverBottomLine = function getDriverBottomLine(offer) {
  return {
    id: 'bottom_line_text',
    label: 'Bottom line',
    value: (0, _insurance.getBottomLine)(offer) || 'No data',
    valueSize: _drivers.VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the coverage options driver
 * @param {object} offer - The marketplace offer.
 * @returns {object} - The insurance driver.
 */


exports.getDriverBottomLine = getDriverBottomLine;

var getDriverCoverageOptions = function getDriverCoverageOptions(offer) {
  return {
    id: 'coverage_options',
    label: 'Coverage options',
    labelTooltip: 'Ratings are based on the number of coverage options a company offers in comparison to other insurers.',
    value: (0, _insurance.getCoverageOptions)(offer) || 'No data',
    valueSize: _drivers.VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the discounts driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The insurance driver.
 */


exports.getDriverCoverageOptions = getDriverCoverageOptions;

var getDriverDiscounts = function getDriverDiscounts(offer) {
  return {
    id: 'discounts',
    label: 'Discounts',
    labelTooltip: 'Ratings are based on the number of discounts a company offers in comparison to other insurers.',
    value: (0, _insurance.getDiscounts)(offer) || 'No data',
    // do not respect 0
    valueSize: _drivers.VALUE_SIZES.MEDIUM
  };
};
/** Get the ease of use driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The insurance driver.
 */


exports.getDriverDiscounts = getDriverDiscounts;

var getDriverEaseOfUse = function getDriverEaseOfUse(offer) {
  return {
    id: 'ease_of_use',
    label: 'Ease of use',
    labelTooltip: 'Ratings are determined by our editorial team. Our "ease of use" category looks at factors such as website transparency and how easy it is to file a claim.',
    value: (0, _insurance.getEaseOfUse)(offer) || 'No data',
    // do not respect 0
    valueSize: _drivers.VALUE_SIZES.MEDIUM
  };
};
/** Get the NAIC complaints driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The insurance driver.
 */


exports.getDriverEaseOfUse = getDriverEaseOfUse;

var getDriverNAICComplaints = function getDriverNAICComplaints(offer) {
  return {
    id: 'naic_complaints',
    label: 'NAIC complaints',
    labelTooltip: "Ratings are based on complaints to state regulators relative to a company's size, according to three years' worth of data from the National Association of Insurance Commissioners.",
    value: (0, _format.formatSnakeCase)((0, _insurance.getNAICComplaints)(offer)) || 'No data',
    // do not respect 0
    annotation: (0, _insurance.getNAICComplaintsAnnotation)(offer),
    valueSize: _drivers.VALUE_SIZES.MEDIUM
  };
};
/** Get the can buy online driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The insurance driver.
 */


exports.getDriverNAICComplaints = getDriverNAICComplaints;

var getDriverCanBuyOnline = function getDriverCanBuyOnline(offer) {
  return {
    id: 'can_buy_online',
    label: 'Online purchase',
    labelTooltip: 'This indicates whether the company offers a way to apply for and purchase policies entirely online.',
    value: _drivers.CAN_BUY_ONLINE[(0, _insurance.getCanBuyOnline)(offer)] || 'No data',
    valueSize: _drivers.VALUE_SIZES.MEDIUM,
    valueTooltip: (0, _insurance.getCanBuyOnlineAnnotation)(offer)
  };
};
/** Get the financial strength rating driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The insurance driver.
 */


exports.getDriverCanBuyOnline = getDriverCanBuyOnline;

var getDriverFinancialStrengthRating = function getDriverFinancialStrengthRating(offer) {
  return {
    id: 'financial_strength_rating',
    label: 'Financial strength rating',
    labelTooltip: "These ratings, which indicate an insurer's ability to pay future claims, are based on assessments from independent agencies such as AM Best, Moody's and Fitch.",
    value: (0, _format.formatSnakeCase)((0, _insurance.getFinancialStrengthRating)(offer)) || 'No data',
    valueSize: _drivers.VALUE_SIZES.MEDIUM,
    valueTooltip: (0, _insurance.getFinancialStrengthRatingAnnotation)(offer)
  };
};
/** Get the policies offered driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The insurance driver.
 */


exports.getDriverFinancialStrengthRating = getDriverFinancialStrengthRating;

var getDriverPoliciesOffered = function getDriverPoliciesOffered(offer) {
  return {
    id: 'policies_offered',
    label: 'Policies offered',
    labelTooltip: "Term policies last a set period of time such as 20 years, while permanent policies last a lifetime. No-exam policies don't require a medical exam.",
    value: _drivers.POLICIES_OFFERED[(0, _insurance.getPoliciesOffered)(offer)] || 'No data',
    valueSize: _drivers.VALUE_SIZES.MEDIUM,
    valueTooltip: (0, _insurance.getPoliciesOfferedAnnotation)(offer)
  };
};
/** Get the pay vet directly driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The insurance driver.
 */


exports.getDriverPoliciesOffered = getDriverPoliciesOffered;

var getDriverPayVetDirectly = function getDriverPayVetDirectly(offer) {
  return {
    id: 'pay_vet_directly',
    label: 'Pay vet directly',
    value: (0, _insurance.getPayVetDirectly)(offer) || 'No data',
    valueSize: _drivers.VALUE_SIZES.MEDIUM
  };
};
/** Get the scope of coverage driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The insurance driver.
 */


exports.getDriverPayVetDirectly = getDriverPayVetDirectly;

var getDriverScopeOfCoverage = function getDriverScopeOfCoverage(offer) {
  return {
    id: 'scope_of_coverage',
    label: 'Scope of coverage',
    value: (0, _insurance.getScopeOfCoverage)(offer) || 'No data',
    valueSize: _drivers.VALUE_SIZES.MEDIUM
  };
};
/** Get the ability to customize driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The insurance driver.
 */


exports.getDriverScopeOfCoverage = getDriverScopeOfCoverage;

var getDriverAbilityToCustomizePlan = function getDriverAbilityToCustomizePlan(offer) {
  return {
    id: 'ability_to_customize_plan',
    label: 'Ability to customize plan',
    value: (0, _insurance.getAbilityToCustomizePlan)(offer) || 'No data',
    valueSize: _drivers.VALUE_SIZES.MEDIUM
  };
};

exports.getDriverAbilityToCustomizePlan = getDriverAbilityToCustomizePlan;